var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-recaptcha',{ref:"captcha",attrs:{"sitekey":"6LdwwFUUAAAAAPxTLzdEwcE-wEfkE5fCYNP98DLH"},on:{"verify":function (token) { return _vm.$emit('verify', token); }}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55922ad8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Captcha.vue
// module id = 114
// module chunks = 0